function fixCapitalizationOfProperties(sotData) {
    const data = _.cloneDeep(sotData);
    data.all.from.HH = data.all.from.hh;
    data.all.to.HH = data.all.to.hh;

    delete data.all.from.hh;
    delete data.all.to.hh;

    const nameOfDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    nameOfDays.forEach(name => {
        data.days[name].from.HH = data.days[name].from.hh;
        data.days[name].to.HH = data.days[name].to.hh;

        delete data.days[name].from.hh;
        delete data.days[name].to.hh;
    });
    return data;
}

export default {fixCapitalizationOfProperties};
